/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorRichtextbox from 'base/components/labrador/Richtextbox';

export const DynamicLabradorRichtextbox: typeof LabradorRichtextbox = (props) => {
    return <ErrorBoundary><LabradorRichtextbox {...props} /></ErrorBoundary>;
}
export type DynamicLabradorRichtextboxProps = PropsFromComponent<typeof LabradorRichtextbox>;
